import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FiAlertCircle, FiCheckCircle, FiInfo, FiX } from 'react-icons/fi';
import { LOCAL_PREVIEW } from '../../localPreview';
import AdminIconButton from './AdminIconButton';

export function AdminNotifications({ children }) {
  return <div className={`admin-notifications${LOCAL_PREVIEW ? ' is-local-preview' : ''}`}>{children}</div>;
}

export default function AdminNotice({ text, type = 'success', onDismiss }) {
  const anchor = useRef(null);
  const [host, setHost] = useState(null);
  useLayoutEffect(() => {
    const scope = anchor.current.closest('dialog') || anchor.current.closest('.admin-page');
    setHost(scope?.querySelector(':scope > .admin-notifications') || null);
  }, []);
  const Icon = type === 'error' || type === 'warning' ? FiAlertCircle : type === 'success' ? FiCheckCircle : FiInfo;
  const notice = text ? <div className={`admin-message admin-toast ${type}`}>
    <Icon className="admin-toast-icon" aria-hidden="true" />
    <span role={type === 'error' ? 'alert' : 'status'} aria-atomic="true">{text}</span>
    <AdminIconButton label="Dismiss message" icon={FiX} onClick={onDismiss} />
  </div> : null;
  return <><span hidden ref={anchor} />{host ? createPortal(notice, host) : notice && <AdminNotifications>{notice}</AdminNotifications>}</>;
}
